import { api } from './api.js';
import { TAG_FILE, TAG_LIST_FILES } from './tags.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const fileEndpoints = api.enhanceEndpoints({ addTagTypes: ['file'] }).injectEndpoints({
    endpoints: (builder) => ({
        getPresignedUrl: builder.query({
            query: () => ({
                url: '/files/aws/presigned-url',
                method: 'GET'
            })
        }),
        getFiles: builder.query({
            query: ({ category, ...params }) => ({
                url: `/files/${category}?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            providesTags: [TAG_LIST_FILES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getFile: builder.query({
            query: (id) => ({
                url: `/files/view/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_FILE],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        editFile: builder.mutation({
            query: ({ id, data }) => ({
                url: `/files/edit/${id}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_FILES, TAG_FILE],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deleteFile: builder.mutation({
            query: (id) => ({
                url: `/files/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_FILES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        importFiles: builder.mutation({
            query: (data) => ({
                url: '/files/import',
                method: 'POST',
                body: data,
                multipart: true
            }),
            invalidatesTags: [TAG_LIST_FILES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getFileCategories: builder.query({
            query: () => ({
                url: '/misc/file-categories',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        massDeleteFiles: builder.mutation({
            query: (data) => ({
                url: `/files/bulk-delete`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_FILES, TAG_FILE],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        filesAdvancedSearch: builder.query({
            query: (params) => ({
                url: `/files/search?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            providesTags: [TAG_LIST_FILES],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getFilesSimpleSearch: builder.query({
            query: (params) => ({
                url: `/misc/search-files?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});
export const {
    useGetPresignedUrlQuery,
    useLazyGetFilesQuery,
    useGetFileQuery,
    useEditFileMutation,
    useDeleteFileMutation,
    useImportFilesMutation,
    useGetFileCategoriesQuery,
    useMassDeleteFilesMutation,
    useLazyFilesAdvancedSearchQuery,
    useLazyGetFilesSimpleSearchQuery
} = fileEndpoints;
